/**
 * Nepali locale for webhooks-ui.
 * Export is the "webhooks" subtree: host apps merge this into their i18n
 * resources as translation.webhooks so that t('webhooks.list.integrated') etc. resolve.
 */
import type { WebhooksLocale } from './en'

export const webhooksNe = {
  common: {
    createIntegration: `एकीकरण सिर्जना गर्नुहोस्`,
    updateIntegration: `एकीकरण अद्यावधिक गर्नुहोस्`,
    failedToSave: `सेभ गर्न असफल`,
    learnMore: `थप जान्नुहोस्`,
    beta: `बिटा`,
  },
  list: {
    failedToLoad: `एकीकरणहरू लोड गर्न असफल`,
    noIntegrationsAvailable: `कुनै एकीकरण उपलब्ध छैन`,
    integrated: `एकीकृत`,
    learnMore: `थप जान्नुहोस्`,
  },
  detail: {
    status: `स्थिति`,
    on: `चालू`,
    off: `बन्द`,
    failedToLoad: `एकीकरण लोड गर्न असफल`,
    back: `← पछाडि`,
    webhooksV2Title: `Webhooks v2.0`,
    xlDentTitle: `Screen pops का लागि एकीकरण`,
    integrationTitle: `{{name}} का लागि एकीकरण`,
    webhooksV2Description: `इभेन्ट पेलोड तपाईंले प्रदान गर्नुभएको Callback URL मा पठाइनेछ। इभेन्ट चयनकर्ताहरू प्रयोग गरी कुन इभेन्टहरू पठाउने भनी निर्दिष्ट गर्नुपर्नेछ`,
    xlDentDescription: `को फोन गरिरहेको छ भनेर जान्नुहोस्। समय बचत गर्नुहोस्। छिटो जवाफहरू पाउनुहोस्। आउने र जाने कलहरूमा स्क्रिन पप सूचनाहरू प्राप्त गर्नुहोस्`,
    remoteIdLabel: `रिमोट ID`,
    practiceGuidLabel: `प्रेक्टिस GUID`,
  },
  dolphin: {
    webhookUrl: `Webhook URL`,
  },
  webhooksV2: {
    remoteId: `रिमोट ID`,
    remoteIdPlaceholder: `स्रोत पीबीएक्स पहिचान गर्न प्रयोग गरिन्छ।`,
    callbackUrl: `कलब्याक URL`,
    callbackUrlPlaceholder: `https://yourdomain.com/mango/event-handler`,
    eventSelectors: `इभेन्ट चयनकर्ताहरू`,
    eventSelectorsLoadError: `इभेन्ट चयनकर्ताहरू लोड हुन सकेन — पुन: प्रयास गर्न पृष्ठ ताजा गर्नुहोस्।`,
    noEventsWarning: `तपाईंले कुनै इभेन्ट चयनकर्ता छनोट गर्नुभएको छैन, जसको फलस्वरूप त्यो URL मा कुनै इभेन्ट पठाइने छैन। फेरि पनि सेभ गर्ने?`,
    goBack: `पछाडि जानुहोस्`,
    saveAnyway: `फेरि पनि सेभ गर्नुहोस्`,
  },
  xlDent: {
    tableDescription: `Mango Voice एक्सटेन्सनहरूलाई वर्कस्टेशन IP ठेगानासँग म्याप गर्नुहोस्।`,
    extensionName: `एक्सटेन्सन नाम`,
    extensionNumber: `एक्सटेन्सन नम्बर`,
    workstationIp: `वर्कस्टेशन IP ठेगाना`,
    enableDisable: `सक्षम/अक्षम`,
    disabled: `अक्षम।`,
    ipPlaceholder: `e.g. 192.168.1.1:8888`,
    update: `अद्यावधिक गर्नुहोस्`,
    devicesNote: `नोट: कुनै पनि परिवर्तनले तपाईंलाई 'मेरा उपकरणहरू' मा उपकरण अद्यावधिक गर्न आवश्यक पर्नेछ ताकि परिवर्तनहरू लागू होस्।`,
  },
  // यस सेक्सनको पाठ apidocs.mangovoice.com सँग सुसंगत भाषा सुनिश्चित गर्न
  // जानाजानी API कागजातसँग मिलाउन लेखिएको हो।
  authKeys: {
    title: `प्राधिकरण कुञ्जीहरू`,
    description: `Mango Voice ग्लोबल API मा अनुरोधहरू प्रमाणीकरण गर्ने तीन-भाग टोकन उत्पन्न गर्नुहोस्। यसलाई आफ्नो एकीकरण साझेदारसँग साझा गर्नुहोस् ताकि उनीहरूले तपाईंको तर्फबाट API कलहरू गर्न सकून्।`,
    confidential: `टोकनहरू गोप्य राख्नुपर्छ। टोकनहरू सार्वजनिक रूपमा उजागर गर्नाले डेटा चोरी, हानि, वा भ्रष्टाचार हुन सक्छ।`,
    noKeys: `अहिलेसम्म कुनै प्राधिकरण कुञ्जीहरू उत्पन्न गरिएको छैन।`,
    generate: `उत्पन्न गर्नुहोस्`,
    regenerate: `पुनः उत्पन्न गर्नुहोस्`,
    remove: `हटाउनुहोस्`,
    copy: `प्रतिलिपि गर्नुहोस्`,
    copied: `प्रतिलिपि गरियो!`,
    apiDocsLabel: `API कागजात हेर्नुहोस्`,
    failedToLoad: `प्राधिकरण कुञ्जीहरू लोड गर्न असफल भयो`,
    failedToGenerate: `प्राधिकरण कुञ्जीहरू उत्पन्न गर्न असफल भयो`,
    failedToRegenerate: `प्राधिकरण कुञ्जीहरू पुनः उत्पन्न गर्न असफल भयो`,
    failedToRemove: `प्राधिकरण कुञ्जीहरू हटाउन असफल भयो`,
    confirmRegenerateTitle: `प्राधिकरण कुञ्जीहरू पुनः उत्पन्न गर्नुहोस्`,
    confirmRegenerateBody: `प्राधिकरण कुञ्जीहरू पुनः उत्पन्न गर्नाले अवस्थित एकीकरणहरू अक्षम हुन सक्छन्। के तपाईं जारी राख्न चाहनुहुन्छ?`,
    confirmRemoveTitle: `प्राधिकरण कुञ्जीहरू हटाउनुहोस्`,
    confirmRemoveBody: `प्राधिकरण कुञ्जीहरू हटाउनाले अवस्थित एकीकरणहरू अक्षम हुन सक्छन्। के तपाईं जारी राख्न चाहनुहुन्छ?`,
    confirmCancel: `रद्द गर्नुहोस्`,
    confirmProceed: `अगाडि बढ्नुहोस्`,
    combinedToken: `संयुक्त टोकन`,
    combinedTokenHint: `API अनुरोधहरूमा पाथ भेरिएबलको रूपमा प्रयोग गरिन्छ`,
    formatIdent1: `ident1`,
    formatIdent2: `ident2`,
    formatIdent3: `ident3`,
  },
  admin: {
    apiAccess: {
      title: `API पहुँच`,
      selectPbx: `पीबीएक्स छनौट गर्नुहोस्`,
      selectCompanyFirst: `पहिले कम्पनी छनौट गर्नुहोस्`,
      noPbxSelected: `प्राधिकरण कुञ्जीहरू प्रबन्ध गर्न माथि कम्पनी र पीबीएक्स छनौट गर्नुहोस्।`,
    },
    // admin.list is an internal admin3 namespace — English strings are intentional
    list: {
      title: `Webhook Integrations`,
      description: `View and manage webhook integration status across all PBXes for a company`,
      companyLabel: `Company`,
      companyPlaceholder: `Select a company…`,
      pbxFilter: `पीबीएक्स`,
      allPbxes: `All PBXes`,
      integrationFilter: `Integration`,
      allIntegrations: `All Integrations`,
      noCompanySelected: `Select a company to view integrations`,
      noIntegrationsFound: `No integrations found`,
      columnStatus: `Status`,
      columnActive: `Active`,
      notIntegrated: `Not integrated`,
    },
  },
} satisfies WebhooksLocale
